module.exports = __webpack_public_path__ + "f4d3cff967a10bfb78d66c788d8c98f9.jpg";